import { v4 as uuidv4 } from 'uuid';
import { toStorageKeySegment } from './storageKey';

// The list hides other uploaders' files, so they must not block this user's upload.
// Legacy files without an uploader remain visible and keep their duplicate guard.
export function partitionPatientUploads(files, history, patientId, userId) {
  const prefix = `${patientId}/`;
  const names = new Set((history || []).filter(item => item.type === 'Attachment'
    && item.path?.startsWith(prefix) && !item.path.slice(prefix.length).includes('/')
    && (!item.createdByUserId || item.createdByUserId === userId)).map(item => item.title));
  const duplicates = [], uploads = [];
  for (const file of files) {
    if (names.has(file.name)) duplicates.push(file);
    else { names.add(file.name); uploads.push(file); }
  }
  return { duplicates, uploads };
}

// Preserve the original name in metadata; every new storage object is distinct.
export const newPatientStorageName = name => `${uuidv4()}_${toStorageKeySegment(name)}`;
export function patientAttachmentId(file) {
  const storageName = file.path?.split('/').pop() || '';
  const newObject = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}_/i.test(storageName)
    && storageName !== file.name;
  // Existing report document references keep their original IDs.
  return `patient-file-${newObject ? storageName : file.name}`;
}

// Storage success is independent of extraction and the engine's asynchronous index.
export function attachmentIndexingAlert(data, fileNames) {
  const warning = text => ({ type: 'warning', text: `Files uploaded, but ${text}` });
  const results = data?.results;
  if (!Array.isArray(results) || !results.length || results.length !== fileNames.length
    || JSON.stringify(results.map(item => item?.file_name).sort()) !== JSON.stringify([...fileNames].sort())
    || results.some(item => !['complete', 'partial', 'unreadable', 'failed'].includes(item?.status))) {
    return warning(data?.status === 'failed'
      ? 'Ask Sophie could not finish processing them. The saved files are still available.'
      : 'Ask Sophie readiness could not be confirmed. The saved files are still available.');
  }
  if (results.some(item => item.status === 'failed')) return warning('Ask Sophie could not finish processing one or more files. The saved files are still available.');
  if (results.some(item => item.status === 'unreadable')) return warning('Ask Sophie could not read one or more files. Check the file format or contact support.');
  if (data?.status === 'partial' || results.some(item => item.status === 'partial')) return warning('some content could not be read by Ask Sophie. Check the original files.');
  if (data?.status === 'failed') return warning('Ask Sophie could not finish processing them. The saved files are still available.');
  if (results.some(item => item.index_status !== 'ready')) return { type: 'info', text: 'Files uploaded. Ask Sophie is still processing them.' };
  return { type: 'success', text: 'Files uploaded and ready for Ask Sophie.' };
}
